import React from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";

interface alertBoxProps {
  alertTitle?: string;
  onForm?: boolean;
}

const AlertBox: React.FC<alertBoxProps> = ({ alertTitle, onForm }) => {
  return (
    <Box
      sx={{
        width: "100%",
        position: onForm ? "relative" : "absolute",
        zIndex: 5,
        marginTop: "10px",
        display: "flex",
      }}
    >
      <Collapse
        in={true}
        sx={{
          display: "flex",
          width: { xl: "90%", md: "30%" },
          margin: "auto",
          alignItems: "center",
          paddingBottom: "0px",
          "& .MuiAlert-root": {
            paddingBottom: "0px",
          },
        }}
      >
        <Alert
          severity="error"
          sx={{
            fontSize: { xs: "12px", sm: "13px", md: "15px" },
            lineHeight: { xs: "12px", sm: "24px", md: "26px" },
            color: "#333333",
            opacity: 1,
            fontFamily: "Avenir",
            paddingTop: "0px",
            alignItems: "center",
          }}
        >
          {alertTitle}
        </Alert>
      </Collapse>
    </Box>
  );
};

export default AlertBox;
